export type IconName = 'today' | 'deck' | 'pick' | 'spark' | 'history' | 'orders' | 'profile' | 'sun' | 'moon' | 'hourglass' | 'pen' | 'question' | 'mail' | 'check' | 'undo'

export type IconShape =
  | { readonly kind: 'path'; readonly d: string }
  | { readonly kind: 'rect'; readonly x: number; readonly y: number; readonly width: number; readonly height: number; readonly rx: number }
  | { readonly kind: 'circle'; readonly cx: number; readonly cy: number; readonly r: number }

const path = (d: string): IconShape => ({ kind: 'path', d })

export const ICON_SHAPES: Readonly<Record<IconName, readonly IconShape[]>> = {
  today: [path('M20 14.2A8 8 0 1 1 9.8 4a6.4 6.4 0 0 0 10.2 10.2z'), path('M18 3v4M16 5h4')],
  deck: [{ kind: 'rect', x: 5, y: 6, width: 11, height: 15, rx: 2.5 }, path('M8.5 3.5h8A2.5 2.5 0 0 1 19 6v11')],
  pick: [
    { kind: 'rect', x: 3, y: 7, width: 11, height: 14, rx: 2 },
    path('M8 4h9a3 3 0 0 1 3 3v10'),
    path('M8.5 12.2l.9 1.9 2 .3-1.5 1.4.4 2-1.8-1-1.8 1 .4-2-1.5-1.4 2-.3z'),
  ],
  spark: [path('M12 3l2.1 6 6 2.4-6 2.4L12 20l-2.1-6.2-6-2.4 6-2.4z')],
  history: [{ kind: 'circle', cx: 12, cy: 12, r: 8.5 }, path('M12 7.5V12l3 2')],
  orders: [path('M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3z'), path('M9 9h6M9 13h6')],
  hourglass: [path('M7 3h10M7 21h10'), path('M8 3c0 5 4 6 4 9s-4 4-4 9M16 3c0 5-4 6-4 9s4 4 4 9')],
  pen: [path('M4 20l4-1 10-10-3-3L5 16z'), path('M13 7l3 3')],
  question: [path('M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1 .9-1 1.7V15'), { kind: 'circle', cx: 12, cy: 18.5, r: 0.8 }],
  mail: [path('M4 7h16v11H4z'), path('M4 8l8 6 8-6')],
  check: [path('M5 12.5l4.5 4.5L19 7.5')],
  undo: [path('M9 7L5 11l4 4'), path('M5 11h9a5 5 0 0 1 0 10h-2')],
  profile: [{ kind: 'circle', cx: 12, cy: 8.5, r: 3.6 }, path('M5 20c1.2-3.6 4-5.2 7-5.2s5.8 1.6 7 5.2')],
  sun: [
    { kind: 'circle', cx: 12, cy: 12, r: 4 },
    path('M12 2.5V5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8'),
  ],
  moon: [path('M19.5 14.5A8 8 0 0 1 9.5 4.5a8 8 0 1 0 10 10z'), path('M17 3.5l.5 1.5 1.5.5-1.5.5-.5 1.5-.5-1.5-1.5-.5 1.5-.5z')],
}
